import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: 'drivingRoute/page',
    method: 'post',
    data,
  })
}
export async function createData(data) {
  return request({
    url: 'drivingRoute/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: 'drivingRoute/update',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: 'drivingRoute/delete',
    method: 'post',
    data,
  })
}
export async function bindDepart(data) {
  return request({
    url: 'drivingRoute/depart/bind',
    method: 'post',
    data,
  })
}
export async function findDepart(data) {
  return request({
    url: 'drivingRoute/depart/find',
    method: 'post',
    data,
  })
}
export async function getAllLocation(data) {
  return request({
    url: '/location/all',
    method: 'post',
    data,
  })
}
